"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "¿Cuál es el plazo de entrega para recambios urgentes?",
  answer: "Para recambios en stock de excavadoras y maquinaria de obras públicas, ofrecemos envíos exprés de 24/48 horas en península para minimizar el tiempo de inactividad de su flota."
}, {
  question: "¿REALIZAN ENVÍOS INTERNACIONALES?",
  answer: "Sí, exportamos componentes hidráulicos y motores a nivel internacional. Gestionamos toda la documentación necesaria para asegurar que sus repuestos Fiat o Kobelco lleguen a su destino sin retrasos aduaneros."
}, {
  question: "¿Cómo puedo realizar el seguimiento de mi pedido?",
  answer: "Una vez que el recambio sale de nuestro almacén, recibirá un código de seguimiento por WhatsApp o email. También puede contactarnos directamente para conocer el estado en tiempo real de su envío."
}];
export default function CommonInquiries() {
  return <section data-section-id="221681" id="preguntas-frecuentes-sobre-envíos" className="bg-background text-foreground py-24 px-6 md:px-12 lg:px-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/10 blur-[120px] rounded-lg pointer-events-none" />

      <div className="max-w-3xl mx-auto relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-bold font-default mb-4 tracking-tighter uppercase">
            Preguntas Frecuentes sobre Envíos
          </h2>
          <p className="text-muted-foreground text-lg max-w-xl mx-auto font-default font-light">
            Información logística detallada para el transporte de recambios de maquinaria pesada y componentes industriales.
          </p>
        </div>

        {}
        <div className="bg-card border border-border rounded-md p-6 md:p-8 shadow-2xl shadow-black/80 backdrop-blur-sm">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border/60 py-2">
                <AccordionTrigger className="text-left text-base md:text-lg font-bold font-default hover:text-primary transition-colors hover:no-underline uppercase tracking-tight">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base leading-relaxed font-default font-light pt-2 pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}